"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TabList: function() {
        return _index.TabList;
    },
    TabListContext: function() {
        return _index.TabListContext;
    },
    TabListProvider: function() {
        return _index.TabListProvider;
    },
    renderTabList_unstable: function() {
        return _index.renderTabList_unstable;
    },
    tabListClassNames: function() {
        return _index.tabListClassNames;
    },
    useTabListBase_unstable: function() {
        return _index.useTabListBase_unstable;
    },
    useTabListContextValues_unstable: function() {
        return _index.useTabListContextValues_unstable;
    },
    useTabListContext_unstable: function() {
        return _index.useTabListContext_unstable;
    },
    useTabListStyles_unstable: function() {
        return _index.useTabListStyles_unstable;
    },
    useTabList_unstable: function() {
        return _index.useTabList_unstable;
    }
});
const _index = require("./components/TabList/index");
